import AvatarMenuItem from './avatarMenuItem';

export default AvatarMenuItem;
